import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Card, CardBody, Row } from "reactstrap";
import Label from "../../../components/Common/Label";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import Helpers from "../../../helpers/helpers";
import { getProductListingForAccessories } from "../../../store/actions";
import "../../Orders/order.css";
import AccessoriesField from "./AccessoriesField";
import no_data_image from "../../../assets/images/table_empty_image.png";

const getAccessoryCategories = (categories) => (categories || [])
  .filter((cat) => cat.parent_id)
  .map((cat) => ({
    ...cat,
    category_name: cat.display_name || cat.name,
  }));

const Accessories = ({ setFormValues, values, error, categoryListing, setNotification, productListingForAccesories }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    setTempAccessories(values?.product_upsells)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.product_upsells]);

  useEffect(() => {
    setCategoryListing(getAccessoryCategories(categoryListing));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryListing]);


  const [openAccessoriesField, setOpenAccessoriesField] = useState(false)
  const [categoryListingFiltered, setCategoryListing] = useState(categoryListing)
  const [editId, setEditId] = useState("")
  const [edit, setEdit] = useState(false)
  const [tempProduct, setTempProduct] = useState("")
  const [tempAccessories, setTempAccessories] = useState(values?.product_upsells)
  const [errorEmpty, setError] = useState(false)
  const [errorQty, setErrorQty] = useState(false)

  const [tempAccessoriesEmpty, setTempAccessoriesEmpty] = useState({
    category_id: "",
    min_purchase_qty: "",
    max_purchase_qty: "",
    items: [],
    sort_order: "",
    additional_info: "",
  })

  const handleDeleteFiles = (id) => {
    const tempFile = values?.product_upsells
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id !== idx
    )
    // setSelectedAccessoriesItem(filteredFIle);
    setFormValues((prevValues) => ({
      ...prevValues,
      product_upsells: filteredFIle
    }))
    setEdit(false)
    setEditId("")
  }

  const handleEditFiles = (id) => {
    const tempFile = values?.product_upsells
    setEdit(true)
    setEditId(id)
    setOpenAccessoriesField(false)
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id === idx
    )
    setTempAccessories(filteredFIle?.[0])
    handleCheckDuplicate("Edit", filteredFIle?.[0]?.category_id)
    const payloadProduct = {
      keyword: "",
      length: "",
      sort_by: "",
      status: "",
      sales_platform: "",
      product_type: "",
      page: 0,
      sort_order: "asc",
      sort: "",
      category_id: filteredFIle?.[0]?.category_id,
    }
    if (filteredFIle?.[0]?.category_id) {
      dispatch(getProductListingForAccessories(payloadProduct))
    }
  }
  const check = (data) => {
    let validate = true
    let validateOptions = true
    validate = data?.category_id &&
      // !Helpers?.isNullOrEmptyAllowZero(data?.min_purchase_qty) && !Helpers?.isNullOrEmptyAllowZero(data?.max_purchase_qty) && 
      data?.items?.length > 0
    validateOptions = data?.items?.every(y => y?.upsell_product_id &&
      // !Helpers?.isNullOrEmptyAllowZero(y?.min_purchase_qty) && !Helpers?.isNullOrEmptyAllowZero(y?.max_purchase_qty) && 
      (y?.discount_value !== "" && y?.discount_value !== null && y?.discount_value !== undefined) && y?.is_percentage !== "");
    if (!validate || !validateOptions) {
      setError(true)
      setErrorQty(false)
      setNotification({
        open: true,
        msg: "Please complete accessories section!",
        type: "warning",
      })
      validate = false
    } else {
      validate = true
      setError(false)
    }
    return validate
  }

  const checkQty = (data) => {
    let validateQty = true
    let validateOptionQty = true
    let validateItemOverCategory = data && data?.items?.every((x, idx) =>
      parseInt(x?.min_purchase_qty) <= parseInt(data?.max_purchase_qty) && parseInt(x?.max_purchase_qty) <= parseInt(data?.max_purchase_qty)
    )
    let validateItemOverCategoryForMinPurchase = data && data?.items?.every((x, idx) =>
      parseInt(x?.min_purchase_qty) >= parseInt(data?.min_purchase_qty)
    )
    if (parseInt(data?.min_purchase_qty) > parseInt(data?.max_purchase_qty)) {
      validateQty = false;
      setNotification({
        open: true,
        msg: "Max. order qty must be more than min. order qty!",
        type: "warning",
      })
      setErrorQty(true)
      setError(false)
    } else if (!validateItemOverCategory) {
      validateQty = false;
      setNotification({
        open: true,
        msg: "Category's max. purchase qty must be more than product upsell's min/max order qty!",
        type: "warning",
      })
      setErrorQty(true)
      setError(false)
    } else if (!validateItemOverCategoryForMinPurchase) {
      validateQty = false;
      setNotification({
        open: true,
        msg: "Category's min. purchase qty must be more than product upsell's min order qty!",
        type: "warning",
      })
      setErrorQty(true)
      setError(false)
    }
    else {
      validateQty = true
      setErrorQty(false)
    }

    //option qty
    if (data && data?.items?.length > 0) {
      validateOptionQty = data?.items?.every(y => parseInt(y?.max_purchase_qty) >= parseInt(y?.min_purchase_qty))
      if (!validateOptionQty) {
        setNotification({
          open: true,
          msg: "Max. order qty must be more than min. order qty!",
          type: "warning",
        })
        setErrorQty(true)
        setError(false)
      }

    } else {
      validateOptionQty = true
      setErrorQty(false)
    }
    return (validateQty && validateOptionQty)
  }

  const handleSaveEdit = (id) => {
    let validate = check(tempAccessories)
    let validateQty = validate
    // && checkQty(tempAccessories)
    if (validate && validateQty) {
      setEditId("")
      const selectedProduct = categoryListingFiltered && categoryListingFiltered?.length > 0 && categoryListingFiltered?.find(
        (product) => product?.id == tempAccessories?.category_id
      );
      setFormValues((prevValues) => ({
        ...prevValues,
        product_upsells: prevValues?.product_upsells?.map((item, index) =>
          index === id
            ? {
              ...item, // Keep other properties intact if needed
              category_id: tempAccessories?.category_id,
              category_name: selectedProduct?.name,
              parent_category_name: selectedProduct?.parent_name || null,
              min_purchase_qty: tempAccessories?.min_purchase_qty,
              max_purchase_qty: tempAccessories?.max_purchase_qty,
              sort_order: tempAccessories?.sort_order,
              items: tempAccessories?.items,
            }
            : item
        ),
      }));
      setOpenAccessoriesField(false); // Close the modal
      setEdit(false)
      clear()
    }
  }

  const clear = () => {
    setErrorQty(false)
    setError(false)
  }

  const handleAddAccessories = () => {

    let validate = check(tempAccessoriesEmpty)
    let validateQty = validate
    // && checkQty(tempAccessoriesEmpty)

    const selectedProduct = categoryListingFiltered.find(
      (product) => product?.id == tempAccessoriesEmpty?.category_id
    );
    if (validate && validateQty) {
      let temp = values?.product_upsells

      temp.push({
        category_id: tempAccessoriesEmpty?.category_id,
        category_name: selectedProduct?.name,
        parent_category_name: selectedProduct?.parent_name || null,
        min_purchase_qty: tempAccessoriesEmpty?.min_purchase_qty,
        max_purchase_qty: tempAccessoriesEmpty?.max_purchase_qty,
        items: tempAccessoriesEmpty?.items
      })
      // temp.push(tempAccessoriesEmpty)
      setFormValues((prevValues) => ({
        ...prevValues,
        product_upsells: temp
      }))

      setTempAccessoriesEmpty({
        category_id: "",
        min_purchase_qty: "",
        max_purchase_qty: "",
        items: [],
      })
      setOpenAccessoriesField(false); // Close the modal
      clear()

    }

  }

  //add accessories in table
  const handleAddProduct = (data, setData) => {
    if (tempProduct) {
      const selectedProduct = productListingForAccesories && productListingForAccesories?.find(
        (product) => product?.id == tempProduct
      );

      let temp = data
      if (temp?.items && temp?.items?.length > 0) {
        temp?.items.push({
          upsell_product_id: tempProduct,
          upsell_product_name: selectedProduct?.product_name,
          upsell_category_name: selectedProduct?.product_categories?.map((x, idx) =>
            `${Helpers?.capitalizeWords(x?.slug)}${idx !== selectedProduct?.product_categories?.length - 1 ? ", " : ""}`
          ),
          upsell_aspeed_price: selectedProduct?.aspeed_price || selectedProduct?.ariba_price,
          upsell_discounted_aspeed_price: "",
          is_percentage: "",
          discount_value: "",
          min_purchase_qty: "",
          max_purchase_qty: "",
          additional_info: "",
          sort_order: "",
        },)
        setData(temp);
      } else {
        let temp = {
          category_id: data?.category_id,
          category_name: data?.category_name,
          min_purchase_qty: data?.min_purchase_qty,
          max_purchase_qty: data?.max_purchase_qty, // Keep the previous values for all other properties
          items: [
            {
              upsell_product_id: tempProduct,
              upsell_product_name: selectedProduct?.product_name,
              upsell_category_name: selectedProduct?.product_categories?.map((x, idx) => `${Helpers?.capitalizeWords(x?.slug)}${idx !== selectedProduct?.product_categories?.length - 1 ? ", " : ""}`),
              upsell_aspeed_price: selectedProduct?.aspeed_price || selectedProduct?.ariba_price,
              upsell_discounted_aspeed_price: "",
              is_percentage: "",
              discount_value: "",
              min_purchase_qty: "",
              sort_order: "",
              additional_info: "",
              max_purchase_qty: "",
            }, // Add the new accessory
          ],
        }
        setData(temp)

      }

      setTempProduct(""); // Reset tempProduct

    }
  }

  const handleCheckDuplicate = (type, cat_id) => {
    let tempAccessoriesData = values?.product_upsells
    const baseCategories = getAccessoryCategories(categoryListing);

    if (type === "Add") {
      if (tempAccessoriesData?.length > 0) {
        const usedCategoryIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item.category_id);
        const newFilteredCat = baseCategories.filter(cat => !usedCategoryIds.includes(cat.id));
        setCategoryListing(newFilteredCat || [])
      }
    } else {
      if (tempAccessoriesData?.length > 0) {
        let usedCategoryIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item.category_id);
        usedCategoryIds = usedCategoryIds?.length > 0 && usedCategoryIds.filter(id => id !== cat_id);
        const newFilteredCat = baseCategories.filter(cat => !usedCategoryIds?.includes(cat.id));
        setCategoryListing(newFilteredCat || [])
      }
    }

  }

  return (
    <React.Fragment>
      <div className="">
        <Card className="p-3 px-2" >
          <CardBody>
            <div className="setting-header">ACCESSORIES</div>
            <FormHelperText style={{ color: "#74788DCC" }}>Upsell with additional accessories that a buyer can purchase along with the main listing.</FormHelperText>
            <Divider className="my-2 mb-4" />
            <Stack direction={{ xs: "column", sm: "row" }} gap={1} justifyContent={"space-between"} pb={2}>
              <Stack direction={"row"} gap={1}>
                <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <i className="ri-shapes-line" style={{ fontSize: "24px" }}></i>
                </div>
                <div>
                  <span className="setting-form-section-header" >Accessories</span>
                  <Typography><span className="setting-form-subtitle">{values?.product_upsells?.length} category</span></Typography>
                  {error && <FormHelperText sx={{ color: "red" }}>{error.product_upsells || ""}</FormHelperText>}
                </div>
              </Stack>
              <Stack display={"contents"} justifyContent={{ xs: "flex-start", sm: "flex-end" }}>
                <CustomButton
                  borderStyle={"1px solid #282828"}
                  title={"Add upsell category"}
                  press={() => (setOpenAccessoriesField(true), setEdit(true), setEditId(""), handleCheckDuplicate("Add"))}
                  height={40}
                  backgroundColor={'white'}
                  textColor={'#282828'}
                />
              </Stack>
            </Stack>
            <Grid container spacing={2} style={{ minHeight: "30vh" }} justifyContent={values?.product_upsells?.length ? "normal" : "center"} alignItems={values?.product_upsells?.length ? "normal" : "center"}>
              {values?.product_upsells && values?.product_upsells.length > 0 ?
                values?.product_upsells.map((f, i) => {
                  return (
                    <React.Fragment key={i}>
                      <Grid item xs={12} sm={6}>
                        {
                          <div
                            className="mt-1 mb-0"
                            key={i + "-file"}
                            style={{ border: "1px solid #d0d0d0", padding: "10px", borderRadius: "8px", paddingTop: "15px", paddingBottom: "15px" }}
                          >
                            <Grid container flexDirection={"row"}>
                              <Grid item xs={12} sm={9} className="p-2">
                                <Row className="align-items-center">
                                  <Stack className="col-auto" gap={2}>
                                    <span className="" style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828" }}>
                                      {f.parent_category_name ? `${f.parent_category_name} › ${f.category_name}` : (f.category_name || f?.upsell_category_name)}
                                    </span>
                                    <Label.CustomLabel label={`${f?.items?.length} options`} backgroundColor={"#F1F1F1"} />
                                  </Stack>
                                </Row>
                              </Grid>
                              <Grid item xs={12} sm={3} justifyContent={"flex-start"} textAlign={"right"}>
                                <div>
                                  <CustomIconButton
                                    iconName={'ri-pencil-line'}
                                    onClick={(e) => { handleEditFiles(i) }} />
                                  <CustomIconButton
                                    iconName={'ri-delete-bin-line'}
                                    onClick={(e) => handleDeleteFiles(i)}
                                    backgroundColor={'#44d62c'}
                                    color={'white'}
                                    borderStyle={"1px solid #44d62c"}
                                  />
                                </div>
                              </Grid>
                              {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "product_upsells.")}</FormHelperText>}
                            </Grid>
                          </div >
                        }
                      </Grid>
                      {
                        edit && editId === i &&
                        <Grid item xs={12} >
                          <AccessoriesField
                            setNotification={setNotification}
                            errorQty={errorQty}
                            error={errorEmpty}
                            setErrorQty={setErrorQty}
                            setError={setError}
                            productListing={productListingForAccesories}
                            categoryListing={categoryListingFiltered}
                            setOpenAccessoriesField={setOpenAccessoriesField}
                            tempAccessories={tempAccessories}
                            setTempAccessories={setTempAccessories}
                            handleAddAccessories={handleAddAccessories}
                            edit={edit} setEditId={setEditId}
                            handleSaveEdit={handleSaveEdit}
                            id={i} setEdit={setEdit}
                            handleAddProduct={() => handleAddProduct(tempAccessories, setTempAccessories)}
                            setTempProduct={setTempProduct}
                            tempProduct={tempProduct}
                            useeffectIndicator={tempAccessories?.[-1]?.items?.[-1] || {}}
                          />
                        </Grid>
                      }
                    </React.Fragment>

                  );
                })
                :
                !openAccessoriesField &&
                <>
                  <div className="d-flex justify-content-center flex-column align-items-center w-100 pb-2 pt-3" key={'no record-1'} style={{ color: '#999999' }}>
                    <img src={no_data_image} alt="empty-data" style={{ height: 120, width: 120 }} />
                    <span className="pt-2">No accessories added</span>
                  </div>
                </>
              }


              {
                openAccessoriesField &&
                <AccessoriesField
                  setNotification={setNotification}
                  errorQty={errorQty}
                  error={errorEmpty}
                  setErrorQty={setErrorQty}
                  setError={setError}
                  productListing={productListingForAccesories}
                  categoryListing={categoryListingFiltered}
                  setOpenAccessoriesField={setOpenAccessoriesField}
                  tempAccessories={tempAccessoriesEmpty}
                  setTempAccessories={setTempAccessoriesEmpty}
                  handleAddAccessories={handleAddAccessories}
                  edit={false}
                  setEditId={setEditId}
                  handleAddProduct={() => handleAddProduct(tempAccessoriesEmpty, setTempAccessoriesEmpty)}
                  setTempProduct={setTempProduct}
                  tempProduct={tempProduct}
                  useeffectIndicator={tempAccessories?.[-1]?.items?.[-1] || {}}


                />
              }
            </Grid>
          </CardBody>
        </Card >
      </div >
    </React.Fragment >
  );
};

function mapStateToProps({ Product }) {
  return {
    productListingForAccesories: Product.productListingForAccesories,

  };
}


export default connect(mapStateToProps)(Accessories);
